const experiencesList = [
  {
    position: "Full-Stack Developer Jr.",
    company: "3778",
    date: "03/2022 ~ 12/2022",
    items: [
      "Component implementation in React.js",
      "Development and bug fixing in node.js",
      "Unit and Integration tests using JEST, E2E Testing in Cypress",
      "REST and Graphql APIs consuming",
      "Third-party systems integrations",
      "Internal documentation and code reviews",
    ],
    href:"https://3778.care"
  },
  {
    position: "Full-Stack Developer Trainee",
    company: "3778",
    date: "09/2021 ~ 03/2022",
    items: [
      "Component implementation in React.js",
      "Development and bug fixing in node.js",
      "Unit and Integration tests using JEST, E2E Testing in Cypress",
      "Third-party systems integrations",
      "Internal documentation and code reviews",
      "Roles and permissions with Hasura",
    ],
    href:"https://3778.care"
  },
  {
    position: "Full-Stack - personal projects",
    company: "personal",
    date: "02/2019 ~ 10/2021",
    items: [
      "System development using Django, Django Template Language and MongoDB",
      "System development using Node.js, Express and Vue.js",
      "Web Scraping with BeautifulSoup",
      "Pdf's with RepportLab",
    ],
    href:"https://github.com/Gustavo-Ennes"
  },
];

export { experiencesList };
